import React from "react";
import { Typography } from "../../../Components/Typography";

/**
 * Extra student fields under "The Architect of Change".
 * Field `name` is the PATCH/PUT body key sent to `/user` (student profile API).
 *
 * | UI label                           | API key                 |
 * |-----------------------------------|-------------------------|
 * | Why does innovation excite you?    | innovation_excites_you |
 * | How do you define success?         | success                |
 * | Achievement Summary               | achievement            |
 */
export function getStudentExtraFormFields() {
  return [
    {
      name: "github_url",
      label: "GitHub Profile",
      type: "custom",
      required: false,
      render: (value, formData, handleInputChange, error) => (
        <div className="flex items-center">
          <span className="px-4 py-2.5 rounded-l-lg border border-r-0 border-slate-200 bg-slate-50 text-sm text-slate-600">
            https://github.com/
          </span>
          <input
            type="text"
            value={formData.github_url || ""}
            onChange={(e) => handleInputChange("github_url", e.target.value)}
            placeholder="Enter your GitHub profile here"
            className={`flex-1 rounded-r-lg border ${
              error ? "border-red-400" : "border-slate-200"
            } bg-white px-4 py-2.5 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue`}
          />
        </div>
      ),
    },
    {
      name: "section_reflection",
      type: "custom",
      component: (
        <div className="flex flex-col gap-1 py-4 border-t border-b border-slate-200 mt-4 text-left">
          <Typography as="h2" className="text-lg font-bold text-primary-900">
            The Architect of Change
          </Typography>
          <Typography as="p" className="text-sm text-tertiary-600">
            Articulate the values that drive your ambition and the milestones that define your journey.
          </Typography>
        </div>
      ),
    },
    {
      name: "innovation_excites_you",
      label: "Why does innovation excite you?",
      type: "textarea",
      required: false,
      placeholder: "Share what excites you about innovation...",
      rows: 4,
      maxLength: 500,
    },
    {
      name: "success",
      label: "How do you define success?",
      type: "textarea",
      required: false,
      placeholder: "Share how you define success...",
      rows: 4,
      maxLength: 500,
    },
    {
      name: "achievement",
      label: "Achievement Summary",
      type: "textarea",
      required: false,
      placeholder: "Summarize your key achievements...",
      rows: 4,
      maxLength: 500,
    },
  ];
}
